import Vue from 'vue'
import CustomFooter from '@/components/layout/Footer.vue'
import CustomMenu from '@/components/layout/Menu.vue'
import CompoMake from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueDraggableResizable from '@/components/Draggable.vue'
import '@/assets/css/tailwind.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faImage,
  faFont,
  faLock,
  faLockOpen,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Croppa from 'vue-croppa'
// import 'vue-croppa/dist/vue-croppa.css'
Vue.use(Croppa)
library.add(faImage, faFont, faLock, faLockOpen)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.component('compo-make', CompoMake)
Vue.component('custom-footer', CustomFooter)
Vue.component('custom-menu', CustomMenu)
window.$ = require('jquery')
require('summernote/dist/summernote-lite.js')
require('summernote/dist/summernote-lite.css')
new Vue({
  el: '#app',
  router,
  store,
  // render: h => h(App)
})
